module.exports = __webpack_public_path__ + "img/40_38_057_400.efb8c3dd.jpg";